import { render } from "./ActionTag.vue?vue&type=template&id=63782849"
import script from "./ActionTag.vue?vue&type=script&lang=ts"
export * from "./ActionTag.vue?vue&type=script&lang=ts"
script.render = render

export default script